import React from 'react';
import { Box, Fab, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { green } from '@mui/material/colors';
import LoaderComponent from '../../Loader/LoaderComponent';
import EditIcon from '@mui/icons-material/Edit';

import { useDispatch } from 'react-redux';
import { DELETE_BUTTON_TEXT, EDIT_BUTTON_TEXT } from '../../../constants';
import { TASK_DELETE, TASK_EDIT } from '../../../pages/Tasks/TaskConstants';

const UserActions = ({ getTaskForEdit, rowId }) => {
  const [loader, setLoader] = React.useState(false);

  const dispatch = useDispatch();

  const handleEdit = () => {
    getTaskForEdit(rowId);

    dispatch({
      type: TASK_EDIT,
      data: {
        rowId: rowId,
      },
    });
  };
  const handleDelete = () => {
    dispatch({
      type: TASK_DELETE,
      data: {
        rowId: rowId,
      },
    });
  };

  return (
    <Box>
      <Box>
        <Tooltip
          title={
            <Typography sx={{ fontSize: '0.8rem' }}>
              {EDIT_BUTTON_TEXT}
            </Typography>
          }
          placement="left"
        >
          <Fab
            color="info"
            onClick={handleEdit}
            sx={{
              borderRadius: '10px',
              width: '3rem',
              padding: '0',
              height: '5px !important',
              minHeight: '22px !important',
              boxShadow: 'none !important',
            }}
          >
            <EditIcon fontSize="small" />
          </Fab>
        </Tooltip>
      </Box>
      <Box>
        <Tooltip
          title={
            <Typography sx={{ fontSize: '0.8rem' }}>
              {DELETE_BUTTON_TEXT}
            </Typography>
          }
          placement="right"
        >
          <Fab
            color="error"
            sx={{
              // ml: 1,
              borderRadius: '10px',
              boxShadow: 'none !important',
              width: '3rem',
              padding: '0',
              height: '10px',
              minHeight: '22px !important',
            }}
            onClick={handleDelete}
          >
            <DeleteIcon fontSize="small" sx={{ mt: 0 }} />
          </Fab>
        </Tooltip>
      </Box>
      {loader && (
        <Box
          sx={{
            color: green[500],
            position: 'absolute',
            top: -6,
            left: -6,
            zIndex: 1,
          }}
        >
          <LoaderComponent loaderType="circular" />
        </Box>
      )}
    </Box>
  );
};

export default UserActions;
